



















import { DeliveryTime } from '@/models/api/delivery/deliveryMethod'
import { PluginMixin } from '@spa/mixins/plugin'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Emit, Prop } from 'vue-property-decorator'

export interface DeliveryTimeOption {
  code: string
  label: string
}

@Component
export default class SelectDeliveryTime extends Mixins<PluginMixin>(
  PluginMixin
) {
  @Prop({ required: true })
  optionList: DeliveryTimeOption[]

  @Prop({ default: '0' })
  value: string

  onChange(event) {
    const selectedTimeSlot = this.optionList.find(option => option.code === event.target.value)
    if (!selectedTimeSlot) {
      throw new Error(`Selected time slot not found, ID = ${event.target.value}`)
    }

    this.changeDeliveryTimeSlot({
      id: selectedTimeSlot.code,
      label: selectedTimeSlot.label,
    })
  }

  @Emit('change-delivery-time')
  changeDeliveryTimeSlot(_deliveryTime: DeliveryTime) {
    // do nothing
  }
}
